import axios from 'axios';
import { logApiError } from '@/store/api';

const YOUTUBE_BATCH_MAX = 50;
let batchQueue = [];
let batchFlushScheduled = false;

function scheduleBatchFlush(dispatch) {
    if (batchFlushScheduled) return;
    batchFlushScheduled = true;

    Promise.resolve().then(async () => {
        const pending = batchQueue;
        batchQueue = [];
        batchFlushScheduled = false;

        const apiKey = pending[0]?.apiKey;
        const byId = new Map();
        for (const entry of pending) {
            if (!byId.has(entry.videoId)) byId.set(entry.videoId, []);
            byId.get(entry.videoId).push(entry);
        }
        const uniqueIds = [...byId.keys()];

        for (let i = 0; i < uniqueIds.length; i += YOUTUBE_BATCH_MAX) {
            const chunk = uniqueIds.slice(i, i + YOUTUBE_BATCH_MAX);
            try {
                const url = 'https://youtube.googleapis.com/youtube/v3/videos?part=snippet&part=contentDetails';
                const response = await axios.get(`${url}&id=${chunk.join(',')}&key=${apiKey}`);
                const itemsMap = {};
                (response.data?.items || []).forEach(item => {
                    itemsMap[item.id] = item;
                });

                for (const id of chunk) {
                    const item = itemsMap[id];
                    const payload = item ? { items: [item] } : { items: [] };
                    byId.get(id).forEach(entry => entry.resolve(payload));
                }
            } catch (e) {
                logApiError(e, dispatch);
                for (const id of chunk) {
                    byId.get(id).forEach(entry => entry.resolve(false));
                }
            }
        }
    });
}

export default {
    namespaced: true,
    actions: {
        getYouTubeVideoDetails({ dispatch }, payload) {
            return new Promise(resolve => {
                batchQueue.push({
                    videoId: payload.videoId,
                    apiKey: payload.apiKey,
                    resolve,
                });
                scheduleBatchFlush(dispatch);
            });
        },
    },
};
